module.exports = __webpack_public_path__ + "img/subroutes-group-icon.4f167a6f.svg";